import React from 'react'
import { Github, Linkedin, Mail, Instagram, Facebook, Youtube } from 'lucide-react'
import { FaTiktok } from 'react-icons/fa'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-navy-pale dark:bg-navy-deep border-t border-navy-soft dark:border-github-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-navy-dark dark:text-navy-lightest mb-4">
              Shehan Chamika<span className="text-accent">.</span>
            </h3>
            <p className="text-navy-base dark:text-navy-soft mb-4">
              Software Engineering Student | Building digital experiences that make a difference.
            </p>
            <div className="flex gap-4">
              <a
                href="https://github.com/Shehan2004-web"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="GitHub"
              >
                <Github size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/shehan-chamika-334562383"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.facebook.com/shehan.chamika.33671"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/shehanscp"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.tiktok.com/@chamiya_scp"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="TikTok"
              >
                <FaTiktok size={20} />
              </a>
              <a
                href="https://youtube.com/@codemaster-l5e"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a
                href="mailto:chamikascp@gmail.com"
                className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-navy-dark dark:text-navy-lightest mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#projects" className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors">
                  Projects
                </a>
              </li>
              <li>
                <a href="#blog" className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#contact" className="text-navy-base dark:text-navy-soft hover:text-accent transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter (Optional) */}
          <div>
            <h4 className="font-semibold text-navy-dark dark:text-navy-lightest mb-4">Stay Updated</h4>
            <p className="text-navy-base dark:text-navy-soft mb-4 text-sm">
              Subscribe to get notified about new projects and blog posts.
            </p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="your@email.com"
                className="flex-1 px-4 py-2 bg-white dark:bg-github-bg border border-navy-soft dark:border-github-border rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent text-sm text-navy-dark dark:text-github-text"
              />
              <button
                type="submit"
                className="px-4 py-2 bg-navy-medium text-white rounded-lg hover:bg-accent transition-colors text-sm font-medium"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-navy-soft dark:border-github-border">
          <p className="text-center text-navy-base dark:text-navy-soft text-sm flex items-center justify-center gap-1">
            © {currentYear} Shehan Chamika. Built with React & Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer